export const redirectToSalesOrderPage = (slug: string) => {
  window.open(`/ground-control/sales_order_detail/${slug}/`, '_self');
};
